import React, { useCallback } from 'react';

import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  email,
  useNotify,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

import businessResolver from '../../utilities/validators/orgNumber';

import cleaner from '../../utilities/dataProvider/cleaner';
import errorNotification from '../../utilities/errorNotification';
import countries from '../../constants/countries';

const ErrorMessage = () => {
  const { formState: { errors } } = useFormContext();
  const globalError = errors[''];
  return globalError && typeof globalError.message === 'string'
    ? <Typography color="error" marginBottom={4}>{globalError.message}</Typography> : null;
};

const BusinessCreate = () => {
  const notify = useNotify();

  const onError = useCallback((e: unknown) => {
    notify(errorNotification(e), { type: 'error' });
  }, [notify]);

  return (
    <Create transform={cleaner} mutationOptions={{ onError }}>
      <Card variant="outlined">
        <CardContent>
          <SimpleForm resolver={businessResolver} component={Box}>
            <ErrorMessage />
            <TextInput source="customId" label="Custom id" />
            <TextInput source="name" label="Registered name" />
            <TextInput source="registrationNumber" />
            <SelectInput source="residence" choices={countries} label="Registration country" />
            <ReferenceArrayInput perPage={100} label="Groups" source="groups" reference="groups" filter={{ active: true }}>
              <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
            <TextInput source="email" validate={[email()]} />
            <TextInput source="phoneNumber" />
          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};

export default BusinessCreate;
